<template>
    <v-col cols="12">
        <v-card
            elevation="0"
            width="99%"
            class="overflow-y-auto px-2 tabs-card"
        >
            <v-tabs-items v-model="tabSelected">
                <v-tab-item>
                    <Books
                        :reload="reloadBook"
                        :search="search"
                        v-on:loaded="bookLoaded"
                        v-on:purchase="setPurchaseBook"
                    />
                </v-tab-item>
                <v-tab-item>
                    <Avatars
                        :reload="reloadAvatar"
                        :search="search"
                        v-on:loaded="avatarLoaded"
                        v-on:purchase="setPurchaseAvatarPack"
                    />
                </v-tab-item>
                <v-tab-item>
                    <Skins
                        :reload="reloadSkin"
                        :search="search"
                        v-on:loaded="skinLoaded"
                        v-on:purchase="setPurchaseSkin"
                    />
                </v-tab-item>
                <v-tab-item>
                    <Books
                        :favoriteView="tabSelected===3"
                        :reload="reloadFavorites"
                        :search="search"
                        v-on:loaded="favoriteLoadedBooks"
                        v-on:purchase="setPurchaseBook"
                    />
                    <Avatars
                        :favoriteView="tabSelected===3"
                        :reload="reloadFavorites"
                        :search="search"
                        v-on:loaded="favoriteLoadedAvatars"
                        v-on:purchase="setPurchaseAvatarPack"
                    />
                    <Skins
                        :favoriteView="tabSelected===3"
                        :reload="reloadFavorites"
                        :search="search"
                        v-on:loaded="favoriteLoadedSkins"
                        v-on:purchase="setPurchaseSkin"
                    />
                </v-tab-item>
            </v-tabs-items>
            <v-overlay absolute :value="showLoading" opacity="0">
                <v-progress-circular
                    indeterminate
                    color="primary"
                    size="150"
                    :width="15"
                />
            </v-overlay>
        </v-card>
        <PurchaseModal
            :dialog="purchaseDialog"
            :buyData="purchaseData"
            v-on:close="closePurchaseDialog"
            v-on:favorite="favoriteFromPurchaseModal"
        />
    </v-col>
</template>

<script>

import Avatars from '@/components/store/Avatars.vue'
import Books from '@/components/store/Books.vue'
import Skins from '@/components/store/Skins.vue'
import PurchaseModal from '@/components/store/PurchaseModal.vue'

export default {
    props: {
        search: { type: String, default: '' },
        tabSelected: { type: Number, default: 0 }
    },
    components: {
        Avatars,
        Books,
        PurchaseModal,
        Skins
    },
    data() {
        return {
            avatarsReady: false,
            booksReady: true,
            favoriteAvatarsReady: false,
            favoriteBooksReady: false,
            favoriteSkinsReady: false,
            purchaseDialog: false,
            purchaseData: {
                isAvatarPack: false,
                isBook: false,
                isSkin: false,
                value: null
            },
            reloadAvatar: 0,
            reloadBook: 0,
            reloadSkin: 0,
            reloadFavorites: 0,
            skinsReady: false
        }
    },
    computed: {
        showLoading() {
            return (!this.booksReady && this.tabSelected===0)
                || (!this.avatarsReady && this.tabSelected===1)
                || (!this.skinsReady && this.tabSelected===2)
                || (!this.favoriteAvatarsReady && !this.favoriteBooksReady && !this.favoriteSkinsReady && this.tabSelected===3)
        }
    },
    methods: {
        avatarLoaded (loaded) {
            this.avatarsReady = loaded
        },
        bookLoaded (loaded) {
            this.booksReady = loaded
        },
        closePurchaseDialog (bought) {
            if (bought && this.purchaseData.isAvatarPack) {
                this.reloadAvatar += 1
                this.reloadFavorites += 1
            } else if (bought && this.purchaseData.isBook) {
                this.reloadBook += 1
                this.reloadFavorites += 1
            } else if (bought && this.purchaseData.isSkin) {
                this.reloadSkin += 1
                this.reloadFavorites += 1
            }
            this.purchaseDialog = false
            this.purchaseData.isAvatarPack = false
            this.purchaseData.isBook = false
            this.purchaseData.isSkin = false
        },
        favoriteFromPurchaseModal(favoriteType) {
            if (favoriteType === 0) {
                this.reloadAvatar += 1
            } else if (favoriteType === 1) {
                this.reloadBook += 1
            } else {
                this.reloadSkin += 1
            }
            this.reloadFavorites += 1
        },
        favoriteLoadedAvatars (loaded) {
            this.favoriteAvatarsReady = loaded
        },
        favoriteLoadedBooks (loaded) {
            this.favoriteBooksReady = loaded
        },
        favoriteLoadedSkins (loaded) {
            this.favoriteSkinsReady = loaded
        },
        setPurchaseAvatarPack(data) {
            this.purchaseData.isAvatarPack = true
            this.purchaseData.value = JSON.parse(JSON.stringify(data))
            this.purchaseDialog = true
        },
        setPurchaseBook(data) {
            this.purchaseData.isBook = true
            this.purchaseData.value = JSON.parse(JSON.stringify(data))
            this.purchaseDialog = true
        },
        setPurchaseSkin(data) {
            this.purchaseData.isSkin = true
            this.purchaseData.value = JSON.parse(JSON.stringify(data))
            this.purchaseDialog = true
        },
        skinLoaded (loaded) {
            this.skinsReady = loaded
        }
    },
    watch: {
        tabSelected() {
            if (this.tabSelected === 0) {
                this.reloadBook += 1
            }
            if (this.tabSelected === 1) {
                this.reloadAvatar += 1
            }
            if (this.tabSelected === 2) {
                this.reloadSkin += 1
            }
            if (this.tabSelected === 3) {
                this.reloadFavorites += 1
            }
        }
    }
}
</script>
<style scoped>
.tabs-card {
    height: 340px;
}
@media (min-height: 700px) {
    .tabs-card {
        height: 400px;
    }
}
@media (min-height: 750px) {
    .tabs-card {
        height: 450px;
    }
}
@media (min-height: 800px) {
    .tabs-card {
        height: 500px;
    }
}
@media (min-height: 850px) {
    .tabs-card {
        height: 550px;
    }
}
@media (min-height: 900px) {
    .tabs-card {
        height: 600px;
    }
}
@media (min-height: 950px) {
    .tabs-card {
        height: 650px;
    }
}
@media (min-height: 1000px) {
    .tabs-card {
        height: 700px;
    }
}
</style>